import api from './Client';

type TourResponse = { tour: boolean };

export async function fetchTourFlag(): Promise<boolean> {
  const res = await api.get<TourResponse>('/api/mobile/user/tour');
  return Boolean(res.data?.tour);
}

export async function setTourFlag(value: boolean): Promise<void> {
  await api.put('/api/mobile/user/tour', { tour: value });
}